export const authInitialState = {
  mobileNumber: "",
  otp: "",
  otpVerifier: null,
  otpShowResendMessage: false,
  otpResendCount: 5,
}